module.exports = __webpack_public_path__ + "img/emma_far.0c56a859.png";